namespace Areas.Return {
    "use strict";

    //
    //CRUD functions
    //

    export function processMultipleReturn() {
                
        var dataGrid = $('#InspectionReturnGrid').dxDataGrid('instance');
        const dataIds = dataGrid.getSelectedRowKeys();
        if (dataIds.length === 0) {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
        else {

            const newData = { "InspectionIds": dataIds };
            const data = JSON.stringify(newData);
            const url = "/Inspectors/Return/ReturnToRequestor";

            sendRequest(url, data, "PUT", () => { refreshData(dataGrid); });
        }
    }



}
